import { Component, OnInit, Input } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
    selector: 'spinner-overlay',
    templateUrl: './spinner.html',
    styleUrls: ['./spinner.css'],
    standalone: false
})
export class SpinnerComponent implements OnInit {

    constructor() { }

    @Input() value : number = 100;
    @Input() diameter: number = 100;
    @Input() mode : ProgressSpinnerMode ="indeterminate";
    @Input() strokeWidth : number = 10;
    @Input() overlay: boolean = false;
    @Input() color: string = "primary";
    @Input() fullscreen: boolean

    ngOnInit() {

    }
}